export default __webpack_public_path__ + "static/media/fortuneLogo.4df1824f.svg";